import React, { useState, useEffect } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Button,
  TextField,
  Typography,
} from '@mui/material'

import { OrangeButton } from 'components/common/button'
import { useSprTestQuery } from 'services/hooks/supplierPreferenceRules/useSprTestQuery'

const TestPreferenceRuleModal = ({ open, handleClose, uuid }) => {
  const [partNumber, setPartNumber] = useState('')
  const [processedMessages, setProcessedMessages] = useState(null)
  const [showTestButton, setShowTestButton] = useState(true)
  const { data: processRuleData, refetch } = useSprTestQuery(uuid, partNumber)

  const onChangePartNumber = (e) => {
    setPartNumber(e.target.value)
  }

  const onTest = async () => {
    refetch()
  }

  useEffect(() => {
    if (processRuleData) {
      setProcessedMessages(processRuleData)
      setShowTestButton(false)
    }
  }, [processRuleData])

  const onClose = () => {
    setShowTestButton(true)
    setPartNumber('')
    setProcessedMessages(null)
    handleClose()
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='form-dialog-title'
      fullWidth
      maxWidth='sm'
    >
      <DialogTitle id='form-dialog-title'>
        Test Supplier Part Number Rule
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin='dense'
          label='Part Number Rule'
          variant='outlined'
          fullWidth
          value={partNumber}
          onChange={onChangePartNumber}
        />

        {processedMessages && processedMessages.pass && (
          <Box textAlign='center' my={3}>
            <Typography variant='body1' gutterBottom>
              A {processedMessages.part_number_class} part with the part number{' '}
            </Typography>
            <Typography variant='body1' gutterBottom>
              {processedMessages.part_number}
            </Typography>
            <Typography variant='body1' gutterBottom>
              will have supplier preference rules applied in the following
              order:
            </Typography>
            <ul style={{ textAlign: 'left' }}>
              {processedMessages.display_text.map((rank, i) => (
                <li key={'process-message' + i}>
                  <Typography variant='body1' gutterBottom>
                    {rank}
                  </Typography>
                </li>
              ))}
            </ul>
          </Box>
        )}

        {processedMessages && !processedMessages.pass && (
          <Box textAlign='center' my={3}>
            <Typography variant='body1' gutterBottom>
              This part number rule does not match part number
            </Typography>
            <Typography variant='body1' gutterBottom>
              {processedMessages.part_number}
            </Typography>
          </Box>
        )}

        <Box mt={3} display='flex' justifyContent='flex-end'>
          <OrangeButton
            onClick={onClose}
            className='btn-orange'
            color='primary'
            variant='contained'
            style={{ marginRight: '1em' }}
          >
            Close
          </OrangeButton>
          {showTestButton && (
            <Button onClick={onTest} color='primary' variant='contained'>
              Test
            </Button>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  )
}

export default TestPreferenceRuleModal
